module.exports = __webpack_public_path__ + "static/media/lumbering4.32e48785.jpg";